function libnumber_exporter(callback, ShadowRoot){
    if(typeof libphonenumber !== "undefined"){
        callback();
        return;
    }
    turpial.fetch({
        url: [
            "https://cdn.jsdelivr.net/npm/libphonenumber-js@latest/bundle/libphonenumber-max.js",
        ],
        ready: ()=>{
            callback();
        },
    })
}


export {libnumber_exporter}